import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import CtaIcon from "../../baseui/buttons/CtaIcon";
import { getAllTemplate } from "../../../redux/templateSlice";
import { useDispatch } from "react-redux";
import { closeSurveyModal } from "../../../redux/modalSlice";
const SearchTemplate = () => {
  const dispatch = useDispatch();
  const searchTimeout = useRef();
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      dispatch(getAllTemplate({ search }));
    }, 500);
  }, [search]);

  return (
    <div className="serchForm mb-3">
      <div className="relative">
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="form-control"
        />
        <i>
          <Icon icon="carbon:search" />
        </i>
      </div>
      <CtaIcon
        classes="btn cta-primary-light"
        state={{ isNew: true }}
        to="/templates"
        onClick={() => dispatch(closeSurveyModal())}
        btnText="Add new template"
        icon={<Icon icon="ant-design:plus-outlined" />}
      />
    </div>
  );
};

export default SearchTemplate;
